import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/footer/Footer.tsx");
